module.exports = __webpack_public_path__ + "static/media/doctor.e0cd35e9.svg";